import { useLanguage } from "./LanguageContext";
import { OrnamentDivider, IznikTexture } from "./Motifs";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink py-20 md:py-28 text-center overflow-hidden"
    >
      <IznikTexture dark size={300} opacity={0.11} />
      <div className="relative z-10 mx-auto max-w-2xl px-6">
        <OrnamentDivider className="mx-auto w-56 opacity-80" color="#C5A059" />
        <h2 className="mt-8 font-display text-6xl md:text-8xl leading-none tracking-tight text-cream">
          Nurhan <span className="italic text-gold">&amp;</span> Emre
        </h2>
        <p className="mt-6 font-sans text-xs uppercase tracking-[0.3em] text-cream/50">
          04 · 09 · 2026 — Rotterdam
        </p>
        <p className="mt-5 font-sans text-sm text-cream/40">{t.footer.text}</p>
      </div>
    </footer>
  );
}
